import clsx from 'clsx';
import React from 'react';

export const PAYIN_ARROW = '↘';
export const PAYOUT_ARROW = '↗';

export type Direction = 'payin' | 'payout' | 'none';

type Props = {
  direction: Direction;
  /** Use secondary colour for header rows and empty cells. */
  tone?: 'primary' | 'secondary';
  /** Render the pair without the column separators (e.g. for header row). */
  withBorder?: boolean;
};

const cellBase =
  'flex items-center justify-center w-[2lh] min-w-[2lh] shrink-0 font-FragmentMono text-xmd aspect-square';

/**
 * Two side-by-side glyph columns used across the invoice-detail tables.
 * Left column shows the payin arrow when direction is 'payin', right column
 * shows the payout arrow when 'payout'. Centralised so the glyph can change
 * in a single place.
 */
export const DirectionArrowCells = ({
  direction,
  tone = 'primary',
  withBorder = true,
}: Props): JSX.Element => {
  const colour = tone === 'primary' ? 'text-main' : 'text-main-500';
  const border = withBorder ? 'border-r-[0.5px] border-main-200' : '';
  return (
    <div className="flex flex-row">
      <div className={clsx(cellBase, colour, border)}>
        {direction === 'payin' ? PAYIN_ARROW : ''}
      </div>
      <div className={clsx(cellBase, colour, border)}>
        {direction === 'payout' ? PAYOUT_ARROW : ''}
      </div>
    </div>
  );
};

/**
 * Header row variant that always shows both arrows as labels.
 */
export const DirectionArrowHeaderCells = ({
  withBorder = false,
}: {
  withBorder?: boolean;
}): JSX.Element => {
  const border = withBorder ? 'border-r-[0.5px] border-main-200' : '';
  return (
    <div className="flex flex-row">
      <div className={clsx(cellBase, 'text-main-500', border)}>
        {PAYIN_ARROW}
      </div>
      <div className={clsx(cellBase, 'text-main-500', border)}>
        {PAYOUT_ARROW}
      </div>
    </div>
  );
};
